/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { notificationProvisionalConfig } from '../../config/notifications.config';

export interface IStaticProvisionalPagePluginMethods extends IPluginMethodMap {
  getStaticProvisionalPageSync(args?: any): any;
}

export class StaticProvisionalPagePlugin implements IAgentPlugin {
  readonly methods: IStaticProvisionalPagePluginMethods;

  constructor() {
    this.methods = {
      getStaticProvisionalPageSync:
        this.getStaticProvisionalPageSync.bind(this),
    };
  }

  getStaticProvisionalPageSync(args?: any) {
    return {
      notifications: notificationProvisionalConfig,
    };
  }
}
